/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';

/**
 * 
 * @export
 * @interface CreatePalReauthCaseManager201Response
 */
export interface CreatePalReauthCaseManager201Response {
    /**
     * 
     */
    data?: PalReauthCaseManager;
}

/**
 * Check if a given object implements the CreatePalReauthCaseManager201Response interface.
 */
export function instanceOfCreatePalReauthCaseManager201Response(value: object): value is CreatePalReauthCaseManager201Response {
    return true;
}

export function CreatePalReauthCaseManager201ResponseFromJSON(json: any): CreatePalReauthCaseManager201Response {
    return CreatePalReauthCaseManager201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthCaseManager201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthCaseManager201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthCaseManagerFromJSON(json['data']),
    };
}

export function CreatePalReauthCaseManager201ResponseToJSON(json: any): CreatePalReauthCaseManager201Response {
    return CreatePalReauthCaseManager201ResponseToJSONTyped(json, false);
}

export function CreatePalReauthCaseManager201ResponseToJSONTyped(value?: CreatePalReauthCaseManager201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthCaseManagerToJSON(value['data']),
    };
}

